import { Circle, Page } from '@/components';
import { useSearchParams } from '@/hooks';
import { collateralColorPalette } from '@/theme/utils/collateralColorPalette';
import { Flex, Heading } from '@blockanalitica/ui';
import { useTheme } from 'styled-components';
import HistoricTabs from './HistoricTabs';
import IlksTable from './IlksTable';
import KpiOverview from './KpiOverview';
import { LinkButton, ExternalLinkIcon } from '@/components';

export default function SparkPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');
  const theme = useTheme();
  return (
    <Page
      title={
        <Flex gap="3xs" alignItems="center">
          <Circle
            size="3"
            color={collateralColorPalette(
              'spark',
              theme.colors.collateralColors
            )}
          />
          <Heading size="1">Spark</Heading>
        </Flex>
      }
      actions={
        <LinkButton to="https://data.spark.fi/" target="_blank">
          <Flex gap="3xs" alignItems="center" style={{ whiteSpace: 'nowrap' }}>
            Spark Dashboard
            <ExternalLinkIcon size="1" />
          </Flex>
        </LinkButton>
      }>
      <KpiOverview daysAgo={daysAgo} />
      <HistoricTabs />
      <IlksTable daysAgo={daysAgo} />
    </Page>
  );
}
